import React from "react";
import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Search } from "@material-ui/icons";
import { validarDenunciaIntParaPracticas } from "../../../actions/autorizaciones/Autorizaciones";

const FormSolicitudPracticasEnInternacion = (props) => {
  const dispatch = useDispatch();
  const { afiliadoSeleccionado, solicitudSeleccionada } = useSelector((state) => state.autorizaciones);

  const {
    idSolicitudDenunciaInt
  } = props.formValues;

  console.log('afiliadoSeleccionado', afiliadoSeleccionado);

  const validarDenunciaInternacion = () => {
    dispatch(validarDenunciaIntParaPracticas(idSolicitudDenunciaInt, afiliadoSeleccionado?.id_afiliado));
  };

  return (
    <React.Fragment>
      <Grid item xs={12} sx={{ paddingLeft: '0%' }} style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem" }}>
        <TextField
          type="number"
          label="Denuncia de Int. relacionada"
          disabled={solicitudSeleccionada?.idSolicitud}
          value={idSolicitudDenunciaInt}
          onKeyUp={(e) => { if (e.key === 'Enter' && idSolicitudDenunciaInt) validarDenunciaInternacion() }}
          onChange={(e) => {
            if (e.target.value === '' || e.target.value > 0) {
              props.setearValor("idSolicitudDenunciaInt", e.target.value ? Number(e.target.value) : e.target.value);
            }
          }}
          InputProps={{
            endAdornment:
              <InputAdornment position="end">
                <IconButton
                  disabled={solicitudSeleccionada?.idSolicitud}
                  aria-label="Validar"
                  onClick={validarDenunciaInternacion}
                >
                  <Search />
                </IconButton>
              </InputAdornment>
          }}
        />
      </Grid>
    </React.Fragment>
  );
};

export default FormSolicitudPracticasEnInternacion;
